import { FC, useLayoutEffect, lazy, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetTicketLocation } from '../../utils/api/requests/useQueries';
import { useLocationStore } from '../../stores/locationStore';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { PageLoader as CorePageLoader } from '@cfa/react-core';
import { themeSizes } from '../../styles/globalStyleVars';

const FetchError = lazy(() => import('../../components/Global/FetchError'));

const TicketDetailsNoLocation: FC = () => {
  const { setActiveLocation } = useLocationStore();
  const navigate = useNavigate();
  const [ticketNotFound, setTicketNotFound] = useState(false);

  const { id } = useParams<{ id?: string }>();
  const {
    data: ticket,
    error,
    isFetching,
    isSuccess,
    refetch: refetchTicketLocation,
  } = useGetTicketLocation(id ?? '');
  useDocumentTitle('Ticket Details');

  useLayoutEffect(() => {
    if (!isSuccess) return;
    if (ticket && ticket.locationNum) {
      setActiveLocation(ticket.locationNum);
      navigate(`/tickets/${ticket.locationNum}/${id}`);
    } else {
      setTicketNotFound(true);
    }
  }, [isSuccess]);

  return (
    <>
      <div className='container noPadding'>
        <>
          {isFetching && (
            <CorePageLoader style={{ margin: `${themeSizes.xxl} auto` }} />
          )}
          {error && (
            <FetchError
              btnClick={refetchTicketLocation}
              errorType='fetch'
              page='ticketDetails'
            />
          )}
          {ticketNotFound && (
            <FetchError
              btnClick={() => navigate('/tickets')}
              errorType='ticketNotFound'
              page='ticketDetails'
              btnPrimary
            />
          )}
        </>
      </div>
    </>
  );
};
export default TicketDetailsNoLocation;
